module.exports = (__webpack_require__(24))(487);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/tinycolor2/cjs/tinycolor.js from dll-reference lib_core
// module id = 487
// module chunks = 106